import Close from '@mui/icons-material/Close';
import { Button, Dialog, DialogTitle, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import Certidao from './Certidao';

class ModalCertidaoOperacaoLote extends ReactComponent {
    fechar = () => {
        this.observableProps.callbackClose && this.observableProps.callbackClose(this.registro);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            fechar: action,
            registro: computed,
            bloquearEdicaoCertidao: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get bloquearEdicaoCertidao() {
        return (
            this.registro.certidaoJulgamentoTransferida &&
            !this.registro.informacoesAdicionais.permitirQuebraAssinaturaCertidao
        );
    }

    render() {
        return (
            this.observableProps.open && (
                <Dialog
                    open
                    fullWidth
                    maxWidth={'xl'}
                    PaperProps={{ style: { height: '100%', margin: '70px' } }}
                >
                    <DialogTitle style={{ padding: '8px 12px 5px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography
                                style={{ fontSize: '1.1rem' }}
                                display="inline"
                            >
                                Processo Nº {this.registro.processo.numeroCompleto}{' '}
                                {this.bloquearEdicaoCertidao && (
                                    <>
                                        <Typography display="inline">- </Typography>
                                        <Typography
                                            style={{ color: 'red' }}
                                            display="inline"
                                        >
                                            CERTIDÃO BLOQUEADA PARA EDIÇÃO (Transferida para o{' '}
                                            {this.registro.processo.origem})
                                        </Typography>
                                    </>
                                )}
                            </Typography>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '130px' }}>
                                <Tooltip title="Fechar janela">
                                    <div>
                                        <Button
                                            color="secondary"
                                            style={{ minWidth: '24px', padding: '4px' }}
                                            onClick={this.fechar}
                                        >
                                            <Close />
                                        </Button>
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </DialogTitle>
                    <Certidao
                        aberto
                        registro={this.registro}
                    />
                </Dialog>
            )
        );
    }
}

export default inject('stores')(observer(ModalCertidaoOperacaoLote));
